// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const radioColumn = "PropertyForm__radioColumn__typd7";
export const radioBox = "PropertyForm__radioBox__btK6m";
export const radioButton = "PropertyForm__radioButton__9zssZ";
export const radioLabel = "PropertyForm__radioLabel__U21JM";
export const innerForm = "PropertyForm__innerForm__Wc6+b";
export const housingType = "PropertyForm__housingType__WivQo";